import React from 'react'
import { Container } from 'reactstrap'
import { Link } from 'gatsby'

import CollapsibleCard from '../../../CollapsibleCard'
import plan from './assets/plan.svg'
import modernize from './assets/modernize.svg'
import compliant from './assets/compliant.svg'
import global from './assets/global.svg'
import { MANAGED_CLOUD_SUPPORT_ROUTE, CAM_ROUTE } from '../../../../routes'

const ITEMS = [
  {
    title: 'Managed Cloud Support',
    icon: plan,
    stripeColor: 'blue',
    text: 'A comprehensive approach to supporting your cloud deployments.',
    link: <Link to={MANAGED_CLOUD_SUPPORT_ROUTE}>Learn more</Link>,
  },
  {
    title: 'Cloud Architect Manager',
    icon: global,
    stripeColor: 'green',
    text:
      'Work collaboratively with a Solutions Architect to plan, design, and optimize your cloud deployments.',
    link: <Link to={CAM_ROUTE}>Learn more</Link>,
  },
  {
    title: 'Managed Security',
    icon: compliant,
    stripeColor: 'dark-blue',
    text:
      'Meet and maintain any security or compliance needs in health care, government, financial services and more.',
  },
  {
    title: 'Managed DevOps',
    icon: modernize,
    stripeColor: 'orange',
    text:
      'Deploy with the latest trends in DevOps, machine learning, AI and data sciences.',
  },
]

const CustomSolutions = () => {
  return (
    <section className="CustomSolutions">
      <Container>
        <h2 className="CustomSolutions__title">
          Core Managed Solutions&nbsp;
          <span className="text-dark-blue">Offerings</span>
        </h2>

        <div className="CustomSolutions__lead">
          Our team will craft a solution tailored to your business process – no
          matter how complex.
        </div>

        <div className="d-flex flex-column flex-md-row flex-md-wrap align-items-md-stretch">
          {ITEMS.map((item, idx) => (
            <div
              className="w-100 w-md-50 w-lg-25 mb-3 pl-md-2 pr-md-2 mb-lg-0"
              key={idx}
            >
              <CollapsibleCard
                {...item}
                isOpenDefault={idx === 1}
                className="CollapsibleCard--bg-offwhite"
              >
                {item.text}
              </CollapsibleCard>
            </div>
          ))}
        </div>
      </Container>
    </section>
  )
}

export default CustomSolutions
